<div class="dialog__container">
    <header class="dialog__header">
        <h2 class="title__container" *ngIf="title">{{ title | uppercase }}</h2>
        <div class="close-dialog">
            <button
                mat-icon-button
                mat-dialog-close
                class="button-close--outlined"
                color="primary"
                aria-label="Chiudi"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </header>

    <div class="diaolog__content">
        <div class="media__frame">
            <ng-container *ngIf="type === 'image'; else videoTemplate">
                <img src="{{ source }}" />
            </ng-container>

            <ng-template #videoTemplate>
                <video controls>
                    <source src="{{ source }}" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </ng-template>
        </div>

        <div class="description__container" *ngIf="description">
            <p>{{ description }}</p>
        </div>
    </div>

    <div class="cta__container" *ngIf="label">
        <a [href]="data?.url || '#'" target="_blank" class="cta-link">
            <button
                type="button"
                class="fo-btn fo-btn--primary cta-button"
                [ngClass]="{ 'cursor-none': !data?.url }"
            >
                {{ label | uppercase }}
            </button>
        </a>
    </div>
</div>
